import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CustomPrintPanZoomPhoto from '../components/CustomPrintPanZoomPhoto';

const propTypes = {
  albumCustomPrint: PropTypes.shape({
    id: PropTypes.string.isRequired,
    photos_no: PropTypes.number.isRequired,
    custom_print_caption_enabled: PropTypes.bool,
    custom_print: PropTypes.shape({
      id: PropTypes.string.isRequired,
      background_image: PropTypes.shape({
        url: PropTypes.string,
      }),
      account: PropTypes.shape({
        logo_image: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
  config: PropTypes.shape({
    caption: PropTypes.string,
    photos: PropTypes.arrayOf(
      PropTypes.shape({
        photo: PropTypes.shape({
          id: PropTypes.string.isRequired,
        }),
        position: PropTypes.number.isRequired,
        cropbox: PropTypes.object,
      }),
    ),
  }).isRequired,
  onTriggerPhotoSelection: PropTypes.func.isRequired,
  onPhotoCropboxSet: PropTypes.func.isRequired,
};

const CollageConfiguratorTemplate = ({
  albumCustomPrint,
  config,
  onTriggerPhotoSelection,
  onPhotoCropboxSet,
}) => {
  const positions = Array.from({ length: albumCustomPrint.photos_no });
  const backgroundImageUrl =
    albumCustomPrint?.custom_print?.background_image?.url ?? '';
  const accountLogoUrl =
    albumCustomPrint?.custom_print?.account?.logo_image?.url ?? '';

  return (
    <div className="custom-print-config-collage">
      {!!backgroundImageUrl && (
        <img
          src={backgroundImageUrl}
          alt=""
          className="custom-print-config-collage-bg"
        />
      )}

      {!!accountLogoUrl && (
        <img
          src={accountLogoUrl}
          alt=""
          className="custom-print-config-collage-logo"
        />
      )}

      {positions.map((_, index) => {
        const selectedPhoto = config.photos.find(
          photo => photo.position === index,
        );

        return (
          <Fragment key={index}>
            <CustomPrintPanZoomPhoto
              className={classNames({
                'custom-print-photo-collage': true,
              })}
              key={index}
              position={index}
              photo={selectedPhoto?.photo}
              onEdit={onTriggerPhotoSelection}
              onPhotoCropboxSet={onPhotoCropboxSet}
            />

            {index === 0 && (
              <span className="custom-print-config-collage-main-photo-note">
                The center, biggest photo of the collage.
              </span>
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

CollageConfiguratorTemplate.propTypes = propTypes;

export default CollageConfiguratorTemplate;
